import React from "react";

const Header = () => {
  return (
    <div className="">
      <h1 className="text-start p-4 bg-gray-900 shadow-lg text-white text-xl font-semibold">
        Write Your Note
      </h1>
    </div>
  );
};

export default Header;
